export function createTestSessionId(): string {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  return `test-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function shuffleArray<T>(items: T[]): T[] {
  const array = [...items];

  for (let i = array.length - 1; i > 0; i--) {
    let j: number;

    if (typeof crypto !== "undefined" && crypto.getRandomValues) {
      const buffer = new Uint32Array(1);
      crypto.getRandomValues(buffer);
      j = buffer[0] % (i + 1);
    } else {
      j = Math.floor(Math.random() * (i + 1));
    }

    [array[i], array[j]] = [array[j], array[i]];
  }

  return array;
}

export function selectRandomItems<T>(
  pool: T[],
  count?: number | null
): T[] {
  const shuffled = shuffleArray(pool || []);

  if (!count || count <= 0 || count >= shuffled.length) {
    return shuffled;
  }

  return shuffled.slice(0, count);
}
